"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Label: function() {
        return _Label.Label;
    },
    labelClassNames: function() {
        return _Label.labelClassNames;
    },
    renderLabel_unstable: function() {
        return _Label.renderLabel_unstable;
    },
    useLabelStyles_unstable: function() {
        return _Label.useLabelStyles_unstable;
    },
    useLabel_unstable: function() {
        return _Label.useLabel_unstable;
    }
});
const _Label = require("./Label");
